import React from 'react';
import SanctionsCheckGrid from '../../components/vessel-info/sanctions-check-grid/SanctionsCheckGrid';

export default function SanctionsCheckList() {
  return <SanctionsCheckGrid />;
}
